// components/brvm/BrvmSearchHit.jsx — AYA Search ↔ BRVM : société cotée détectée dans la recherche.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TrendingUp, ArrowRight } from "lucide-react";
import { fetchStocks, fmtNum, fmtPct, deltaColor, deltaArrow, tileColor, tileInitials } from "./brvmApi";

let _stocksPromise = null;
function loadStocks() {
  if (!_stocksPromise) _stocksPromise = fetchStocks().then((d) => (d.ok ? d.stocks : [])).catch(() => []);
  return _stocksPromise;
}

const _norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export default function BrvmSearchHit({ query }) {
  const navigate = useNavigate();
  const [hit, setHit] = useState(null);

  useEffect(() => {
    const q = _norm(query).trim();
    if (q.length < 3) { setHit(null); return; }
    let alive = true;
    loadStocks().then((stocks) => {
      if (!alive) return;
      const match = stocks.find((s) => {
        const names = [_norm(s.symbol), _norm(s.short_name), _norm(s.name)];
        return names.some((n) => n === q || n.startsWith(q + " ") || (q.length >= 4 && n.includes(q)));
      });
      setHit(match || null);
    });
    return () => { alive = false; };
  }, [query]);

  if (!hit) return null;

  return (
    <button
      data-testid="brvm-search-hit"
      onClick={() => navigate(`/brvm?symbol=${hit.symbol}`)}
      style={{
        display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left",
        padding: "10px 12px", margin: "8px 0 10px", borderRadius: 14, cursor: "pointer",
        background: "linear-gradient(135deg, rgba(249,115,22,0.10), rgba(8,38,24,0.8))",
        border: "1px solid rgba(249,115,22,0.4)",
      }}
    >
      <span style={{ width: 36, height: 36, borderRadius: 9, background: tileColor(hit.symbol), color: "#fff", fontWeight: 900, fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        {tileInitials(hit.short_name, hit.symbol)}
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{ fontSize: 13, fontWeight: 800, color: "#ECF5EE" }}>{hit.short_name}</span>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 3, padding: "1.5px 7px", borderRadius: 999, background: "rgba(249,115,22,0.16)", color: "#F97316", fontSize: 8.5, fontWeight: 900, letterSpacing: 0.5 }}>
            <TrendingUp size={9} /> DONNÉES BRVM
          </span>
        </div>
        <div style={{ fontSize: 11.5, color: "#CFE5D6", marginTop: 2, fontWeight: 600 }}>
          {fmtNum(hit.close)} FCFA{" "}
          <span style={{ color: deltaColor(hit.delta_pct), fontWeight: 800 }}>{fmtPct(hit.delta_pct)} {deltaArrow(hit.delta_pct)}</span>
        </div>
      </div>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4, color: "#F97316", fontSize: 11, fontWeight: 800, flexShrink: 0 }}>
        Voir la fiche <ArrowRight size={12} />
      </span>
    </button>
  );
}
